module.exports = __webpack_public_path__ + "img/octal_file_mode.65204000.png";